import { $, $$ } from '../../../shared/js/utils/dom';
import { Marquee } from '../../atoms/marquee/package/marquee';

// Select the elements that contain the marquee__inner and marquee__item elements
const marqueeElementList = $$('.nav-marquee .marquee');

if (marqueeElementList.length) {
  marqueeElementList.forEach(element => {
    const innerElement = $('.marquee__inner', element);
    const itemElement = $('.marquee__item', element);
    const linkElement = $('.marquee__link', element);
    const toggleButton = $('.nav-marquee__button');
    const updateToggle = function (state) {
      state['is-running']
        ? toggleButton.classList.add('is-running')
        : toggleButton.classList.remove('is-running');
    };
    const uniqueStr = `${Math.floor(
      Math.random() * Math.floor(Math.random() * Date.now())
    )}`;
    const addAria = () => {
      const id = `marquee-${uniqueStr}`;
      element.setAttribute('id', id);
      toggleButton.setAttribute('aria-controls', id);
    };

    const marquee = new Marquee(element, {
      innerElement,
      itemElement,
      speed: 7,
      pauseOnHover: true,
      stateChangeCallback: function (state) {
        updateToggle(state);
      },
    });

    marquee.init();

    linkElement?.addEventListener('focusin', marquee.stop);
    linkElement?.addEventListener('focusout', marquee.start);
    toggleButton.addEventListener('click', marquee.toggle);

    addAria();
  });
}
